export default __webpack_public_path__ + "static/media/073-alarm-1.62eeceee.svg";